import React from 'react';

// chakra imports
import {
    Box,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerOverlay,
    Flex,
    Icon,
    useColorModeValue,
    useDisclosure,
} from '@chakra-ui/react';
import Content from 'components/sidebar/components/Content';

// Assets
import { IoMenuOutline } from 'react-icons/io5';

function Sidebar(props: { routes: RoutesType[]; [x: string]: any }) {
    const { routes } = props;

    let variantChange = '0.2s linear';
    let shadow = useColorModeValue('14px 17px 40px 4px rgba(112, 144, 176, 0.08)', 'unset');
    // Chakra Color Mode
    let sidebarMargins = '0px';

    // SIDEBAR
    return (
        <Box
            display={{ sm: 'none', xl: 'block' }}
            position="fixed"
            minH="100vh"
            bgColor="gray.100"
            padding="8px 0 0 8px"
            width="290px"
        >
            <Box
                borderRadius="16px"
                bg="white"
                transition={variantChange}
                w="100%"
                h="calc(100vh - 16px)"
                m={sidebarMargins}
                overflowX="hidden"
                boxShadow={shadow}
            >
                <Content routes={routes} />
            </Box>
        </Box>
    );
}

// FUNCTIONS
export function SidebarResponsive(props: { routes: RoutesType[] }) {
    let sidebarBackgroundColor = useColorModeValue('white', 'navy.800');
    let menuColor = useColorModeValue('gray.400', 'white');
    // // SIDEBAR
    const { isOpen, onOpen, onClose } = useDisclosure();
    const btnRef = React.useRef();

    const { routes } = props;
    // let isWindows = navigator.platform.startsWith("Win");
    //  BRAND

    return (
        <Flex display={{ sm: 'flex', xl: 'none' }} alignItems="center">
            <Flex ref={btnRef} w="max-content" h="max-content" onClick={onOpen}>
                <Icon
                    as={IoMenuOutline}
                    color={menuColor}
                    my="auto"
                    w="20px"
                    h="20px"
                    me="10px"
                    _hover={{ cursor: 'pointer' }}
                />
            </Flex>
            <Drawer
                isOpen={isOpen}
                onClose={onClose}
                placement={document.documentElement.dir === 'rtl' ? 'right' : 'left'}
                finalFocusRef={btnRef}
            >
                <DrawerOverlay />
                <DrawerContent w="285px" maxW="285px" bg={sidebarBackgroundColor}>
                    <DrawerCloseButton
                        zIndex="3"
                        onClick={onClose}
                        _focus={{ boxShadow: 'none' }}
                        _hover={{ boxShadow: 'none' }}
                    />
                    <DrawerBody maxW="285px" px="0rem" pb="0">
                        <Content routes={routes} />
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </Flex>
    );
}
// PROPS

export default Sidebar;
